import type { RouteRecordRaw } from 'vue-router';

export const infoFeatureRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/feature',
    name: 'infoFeature',
    redirect: '/info/feature/list',
    component: () => import('pages/info/feature/McFeature.vue'),
    meta: {
      title: 'Features',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'infoFeatureList',
        component: () => import('pages/info/feature/FeatureList.vue'),
        meta: {
          title: 'Features List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'infoFeatureDetail',
        component: () => import('pages/info/feature/FeatureDetail.vue'),
        meta: {
          title: 'Feature Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'infoFeatureNew',
        component: () => import('pages/info/feature/FeatureNew.vue'),
        meta: {
          title: 'New Feature',
          requiresAuth: true,
        },
      },
    ],
  },
];
